<template>
    <div class="relative lg:min-h-screen">
        <div class="feature-image-wrapper shadow-inner max-h-screen-80 h-200 md:h-340 lg:h-640 md:w-340 lg:w-640 md:absolute top-0 right-0">
            <parallax>
                <cdn-image :src="image"
                           :alt="title ?? (langPrefix ? $t(langPrefix + '.title') : null)"
                           :size="{width: '100vw', md: {width: 340}, lg: {width: 640}, xl: {width: 740}}" cover immediate/>
            </parallax>
        </div>
        <div class="relative md:static feature-image-content bg-white">
            <container>
                <div class="flex items-center lg:min-h-screen w-full md:max-w-400 lg:max-w-500">
                    <div class="mb-32 md:mb-96 pt-24 md:pt-48 lg:pr-80 xl:pr-96">
                        <div v-if="$device.isDesktop || !hideTitleOnMobile" class="flex flex-column items-start mb-24">
                            <lazy-badge v-if="newBadge" color="secondary" class="text-uppercase mb-8" rounded-large spaced large>{{ $t('label.new') }}</lazy-badge>
                            <lazy-badge v-else-if="betaBadge" color="secondary" class="text-uppercase mb-8" rounded-large spaced large>BETA</lazy-badge>
                            <h1 v-if="title || langPrefix" class="mb-0 font-bold feature-screen-title" v-html="title ? title : $t(langPrefix + '.title')"/>
                        </div>

                        <p v-if="showDescription && (description || langPrefix)" class="font-heading text-md sm:text-lg leading-wide mb-24 w-full" v-html="description ?? $t(langPrefix + '.description')"/>
                        <slot name="description"/>

                        <div v-if="$slots.default" class="w-full">
                            <slot/>
                        </div>
                        <wrapper v-if="$slots.cta" class="w-full mt-20 sm:mt-24 md:mt-32" grow left break-column="xs" break-reverse>
                            <slot name="cta"/>
                        </wrapper>
                    </div>
                </div>
            </container>
        </div>
    </div>
</template>

<script>
export default {
        name: "FeatureScreen",

        props: {

            // The title to show
            title: {
                type: String,
                default: null
            },

            // The description to show
            description: {
                type: String,
                default: null
            },

            // The lang key prefix for the text to show
            langPrefix: {
                type: String,
                default: null
            },

            // The image to sho on the screen
            image: {
                type: String,
                required: true
            },

            // The feature text alignment
            align: {
                type: String,
                default: 'right'
            },

            // Whether to vertically align the content on the top
            top: {
                type: Boolean,
                default: false
            },

            hideTitleOnMobile: {
                type: Boolean,
                default: false
            },

            // Whether to show a description
            showDescription: {
                type: Boolean,
                default: true
            },

            // Whether a new badge shall be placed next to the title
            newBadge: {
                type: Boolean,
                default: false
            },

            // Whether a beta badge shall be placed next to the title
            betaBadge: {
                type: Boolean,
                default: false
            }
        }
    }
</script>
<style>
/*********************
  Inputs
**********************/
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
.app h1.feature-screen-title {
  font-size: 2.6rem;
}
@media (max-width: 1279px) {
  .app h1.feature-screen-title {
    font-size: 2.4rem;
  }
}
@media (max-width: 1023px) {
  .app h1.feature-screen-title {
    font-size: 2rem;
  }
}
@media (max-width: 767px) {
  .app h1.feature-screen-title {
    font-size: 1.8rem;
  }
}
@media (max-width: 639px) {
  .app h1.feature-screen-title {
    font-size: 1.6rem;
  }
}
.app .feature-image-wrapper {
  border-bottom-left-radius: 85%;
  overflow: hidden;
  position: relative;
  z-index: 1;
}
@media (max-width: 767px) {
  .app .feature-image-wrapper {
    border-bottom-left-radius: 0;
    width: 100%;
  }
  .app .feature-image-wrapper > div {
    top: -30%;
    position: relative;
  }
}
.app .feature-image-content {
  z-index: 2;
}
@media (max-width: 767px) {
  .app .feature-image-content {
    margin-top: -24px;
    border-top-right-radius: 7px;
    border-top-left-radius: 7px;
  }
}
</style>
